import React, { useState } from 'react';
import Ventas from './reports/Ventas';
import BlockHeader from '../../components/shared/BlockHeader';
import Title from '../../components/shared/Title';
import ResumenVentas from './reports/ResumenVentas';
import ResumenVentasVendedor from './reports/ResumenVentasVendedor';
import ResumenVentasPorDia from './reports/ResumenVentasPorDia';
import ResumenVentasPorCategoria from './reports/ResumenVentasPorCategoria';

// Componente principal con tabs
const ReporteTabs = (props) => {
  const [activeTab, setActiveTab] = useState('op1');

  const title = 'Reporte de Ventas';

  return (
    <div className='container'>
        <Title title={title} />
        <BlockHeader title={title} showFavorite={true} {...props}>           
        </BlockHeader>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <button className={`btn btn-default ${activeTab == 'op1' ? 'active':''}`} onClick={() => setActiveTab('op1')}>Resumen de ventas</button>
        <button className={`btn btn-default ${activeTab == 'op2' ? 'active':''}`} onClick={() => setActiveTab('op2')}>Reporte por productos</button>
        <button className={`btn btn-default ${activeTab == 'op3' ? 'active':''}`} onClick={() => setActiveTab('op3')}>Resumen de ventas vendedor</button>
        <button className={`btn btn-default ${activeTab == 'op4' ? 'active':''}`} onClick={() => setActiveTab('op4')}>Reporte de ventas por dia</button>
        <button className={`btn btn-default ${activeTab == 'op5' ? 'active':''}`} onClick={() => setActiveTab('op5')}>Reporte de ventas por categoria</button>
      </div>
      <div style={{ display: activeTab === 'op1' ? 'block' : 'none' }}>
        <ResumenVentas {...props} />
      </div>
      <div style={{ display: activeTab === 'op2' ? 'block' : 'none' }}>
        <Ventas {...props} />
      </div>
      <div style={{ display: activeTab === 'op3' ? 'block' : 'none' }}>
        <ResumenVentasVendedor />
      </div>
      <div style={{ display: activeTab === 'op4' ? 'block' : 'none' }}>
        <ResumenVentasPorDia />
      </div>
      <div style={{ display: activeTab === 'op5' ? 'block' : 'none' }}>
        <ResumenVentasPorCategoria />
      </div>
    </div>
  );
};

export default ReporteTabs;
